import { createContext, useContext, useEffect, useState } from "react";

const NotesContext = createContext([]);

const initialNotes = [
    {
        id: 1,
        title: "Welcome Note ✨",
        note: "This is your first note! You can edit or delete it, and add as many new notes as you like. Try clicking on 'New Note' to create your own.",
        created_at: new Date().toISOString(),
    },
];

export const NotesProvider = ({ children }) => {
    const [notes, setNotes] = useState(() => {
        try {
            const savedNotes = JSON.parse(localStorage.getItem("notes_bl"));
            return savedNotes && Array.isArray(savedNotes)
                ? savedNotes
                : initialNotes;
        } catch (err) {
            console.error("Error loading notes:", err);
            return initialNotes;
        }
    });

    useEffect(() => {
        if (notes.length > 0) {
            localStorage.setItem("notes_bl", JSON.stringify(notes));
        } else {
            localStorage.removeItem("notes_bl");
        }
    }, [notes]);

    /* const handleNotesChanges = (selectedId, isNewNote) => {
        const updatedNotes = [...notes];
        const noteId = updatedNotes.findIndex((n) => n.id === selectedId);

        if (noteId === -1) return;
        const currentNote = updatedNotes[noteId];
        if (
            isNewNote &&
            currentNote.note.trim() === "" &&
            currentNote.title.trim() === ""
        ) {
            updatedNotes.splice(noteId, 1);
            setNotes(updatedNotes);
        } else if (
            !isNewNote &&
            currentNote.note.trim() === "" &&
            currentNote.title.trim() === ""
        ) {
            updatedNotes.splice(noteId, 1);
            setNotes(updatedNotes);
        } else if (!currentNote.title.trim() && currentNote.note.trim()) {
            currentNote.title = currentNote.note
                .split(" ")
                .slice(0, 3)
                .join(" ");
            setNotes(updatedNotes);
        }
    }; */

    const handleFieldsChanges = (id, field, value) => {
        if (!id) return;
        const updatedNotes = [...notes];
        const noteId = updatedNotes.findIndex((note) => note.id === id);
        if (noteId === -1) return;
        updatedNotes[noteId][field] = value;
        setNotes(updatedNotes);
    };

    const cleanNotes = () => {
        const updatedNotes = notes.filter(
            (note) => note.note.trim() !== "" || note.title.trim() !== ""
        );

        const finalNotes = updatedNotes.map((note) => {
            if (!note.title.trim() && note.note.trim()) {
                return {
                    ...note,
                    title: note.note.split(" ").slice(0, 3).join(" "),
                };
            }
            return note;
        });

        if (JSON.stringify(notes) !== JSON.stringify(finalNotes)) {
            setNotes(finalNotes);
        }
    };

    const removeNote = (id) => {
        const updatedNotes = notes.filter((note) => note.id !== id);
        setNotes(updatedNotes);
    };

    return (
        <NotesContext.Provider
            value={{
                notes,
                setNotes,
                handleFieldsChanges,
                removeNote,
                cleanNotes,
            }}
        >
            {children}
        </NotesContext.Provider>
    );
};

export const useNotes = () => {
    return useContext(NotesContext);
};
